import React from 'react';

import { StyledSectionMessageWrapper, StyledTableData } from '../StyledComponents';
import SectionMessage from '@atlaskit/section-message';
import t from '../../../../i18n/intl';
import config from '../../../../../appconfig';

const pmspLink = (chunks) => (
  <a href={`${config.atlAdminUrl}/partner-managed-subscriptions`}>{chunks}</a>
);
const billingConsoleLink = (chunks) => <a href="https://admin.atlassian.com/billing">{chunks}</a>;
const dataCenterBACLink = (chunks, txaId, ccpEntitlementId) => (
  <a href={`${config.atlAdminUrl}/billing/${txaId}/entitlement/${ccpEntitlementId}`}>{chunks}</a>
);

const renderMigratedSubscriptionBanner = (accountDetails) => {
  if (accountDetails?.merchandise?.productPackage?.isDataCenter === true && accountDetails?.slug) {
    return t(
      {
        id: 'mac.licenses.manage.dc.subscriptions.text',
        defaultMessage:
          'You can now manage this subscription as {slug} in <link>Atlassian Billing Console.</link>',
      },
      {
        link: (chunks) =>
          dataCenterBACLink(
            chunks,
            accountDetails?.transactionAccountId,
            accountDetails?.ccpEntitlementId,
          ),
        slug: <strong>{accountDetails?.slug}</strong>,
      },
    );
  }
  return t(
    {
      id: 'mac.licenses.manage.cloud.subscriptions.text',
      defaultMessage:
        'You can now manage your cloud subscriptions in <link>Atlassian Billing Console.</link>',
    },
    {
      link: (chunks: string) => billingConsoleLink(chunks),
    },
  );
};

const renderPartnerMigratedSubscriptionBanner = (accountDetails) => {
  if (accountDetails?.merchandise?.productPackage?.isDataCenter === true && accountDetails?.slug) {
    return t(
      {
        id: 'mac.licenses.see.partner.managed.details.data.center',
        defaultMessage:
          'See details for this subscription as {slug} at the <link>partner managed subscription portal</link>.',
      },
      {
        link: (chunks) => pmspLink(chunks),
        slug: <strong>{accountDetails?.slug}</strong>,
      },
    );
  }
  return t(
    {
      id: 'mac.licenses.see.partner.managed.details',
      defaultMessage:
        'See details for this subscription at the <link>partner managed subscription portal</link>.',
    },
    {
      link: (chunks: string) => pmspLink(chunks),
    },
  );
};

const MigratedSubscriptionBanner = ({ accountDetails, userOrgDetails }) => {
  const isPartnerManaged = accountDetails?.partnerManaged;
  const isDifferentPartner = userOrgDetails?.id !== accountDetails?.latestPeriod?.partnerId;

  return (
    <StyledTableData $paddingLeft colSpan={5}>
      <StyledSectionMessageWrapper>
        <SectionMessage appearance="information">
          {isPartnerManaged && isDifferentPartner
            ? renderPartnerMigratedSubscriptionBanner(accountDetails)
            : renderMigratedSubscriptionBanner(accountDetails)}
        </SectionMessage>
      </StyledSectionMessageWrapper>
    </StyledTableData>
  );
};

export default MigratedSubscriptionBanner;
